const castValueAsNumber = (value) => (value && !Number.isNaN(+value) ? +value : undefined);

export default castValueAsNumber;
